// services/passwordPolicy.js — правилото за НОВА парола, едно за сървъра и
// за екраните (рецензия 27.10.2026, т. 8).
//
// Защо 12 знака: 8 знака се налучкват за часове при изтекла база; дълга
// фраза, която човек помни, е по-сигурна от кратка и „сложна". Важи само за
// новите пароли — заварените не се пипат, докато собственикът не ги смени.
// Списъкът с най-честите пароли е кратък нарочно: хваща очевидното
// („123456789012", „passwordpassword", „qwertyuiop12"), не е речник.

const MIN = 12;

const COMMON = [
  '123456789012', '1234567890123', '12345678901234', '123456123456', '111111111111', '000000000000',
  '123123123123', '121212121212', '112233445566', '987654321098', '098765432109',
  'qwertyuiop12', 'qwertyuiop123', 'qwerty123456', 'qwertyqwerty', 'asdfghjkl123', '1q2w3e4r5t6y',
  'passwordpassword', 'password1234', 'password12345', 'password123456', 'passw0rd1234', 'p@ssword1234',
  'iloveyou1234', 'letmein12345', 'welcome12345', 'admin1234567', 'administrator', 'adminadmin12',
  'changeme1234', 'abc123abc123', 'abcdefghijkl', 'aaaaaaaaaaaa', 'zaq12wsxcde3', 'trustno11234',
  'parola123456', 'parolaparola', 'sofia1234567', 'bulgaria1234', 'bvkont123456', 'crm123456789',
];
const COMMON_SET = new Set(COMMON);

// Текстът на отказа или '' — на прост български, за човека пред екрана.
function passwordError(password, ctx) {
  const p = String(password || '');
  if (p.length < MIN) return 'Паролата трябва да е поне ' + MIN + ' знака — например фраза от няколко думи.';
  const low = p.toLowerCase();
  if (COMMON_SET.has(low)) return 'Тази парола е сред най-често налучкваните — изберете друга.';
  if (/^(.)\1+$/.test(p)) return 'Паролата не бива да е един и същ знак.';
  const email = String((ctx && ctx.email) || '').toLowerCase();
  const local = email.split('@')[0];
  if (local && local.length >= 4 && low.includes(local)) return 'Паролата не бива да съдържа имейла Ви.';
  return '';
}

module.exports = { MIN, COMMON, passwordError };
